import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BaseModal, { BaseModalProps } from '../../../ui/modals/core/BaseModal.tsx';
import MainText from '../../../ui/typography/MainText.tsx';
import Flex from '../../../ui/layout/Flex.tsx';
import SecondaryButton from '../../../ui/buttons/SecondaryButton.tsx';
import PrimaryButton from '../../../ui/buttons/PrimaryButton.tsx';
import HyperLink from '../../../ui/HyperLink.tsx';
import Routes from '../../../router/routes.enum.ts';
import { EMAIL, PHONE_NUMBER } from '../../../constants/config.ts';
import { useGlobalStore } from '../../../providers/GlobalStoreProvider.tsx';
import { UserRoles } from '../../../constants/entities.ts';

type Props = Pick<BaseModalProps, 'open' | 'onClose'>;

const CompanyVerificationRequiredModal: FC<Props> = ({ ...props }) => {
  const { t } = useTranslation('component/company_verification_modal');
  const navigate = useNavigate();
  const {
    user: {
      data: { role },
    },
  } = useGlobalStore();

  const handleCheckStatus = () => {
    props.onClose();
    navigate(Routes.AgencySettings);
  };

  const isAgencyManager = role === UserRoles.AgencyManager;

  return (
    <BaseModal {...props} title={t('title')} className="!max-w-[600px]">
      <MainText className="mt-[24px] leading-6">
        {t('description_part_1')}
        <br />
        {t('description_part_2')}
        <br />
        {t('description_part_3')}
        {' '}
        <br />
        <HyperLink
          to={`mailto:${EMAIL}`}
          className="[&>p]:!text-system-info [&>p]:!text-main [&>p]:!font-normal [&>p]:hover:!text-primary [&>p]:transition-all"
        >
          {EMAIL}
        </HyperLink>
        {' '}
        {t('description_part_4')}
        {' '}
        <span className="text-black font-bold">
          {PHONE_NUMBER}
        </span>
        .
      </MainText>

      {isAgencyManager && (
        <Flex.Wrapper className="flex-wrap gap-x-[24px] gap-y-[16px] mt-[32px]">
          <div className="flex-1 min-w-[150px]">
            <SecondaryButton className="whitespace-nowrap w-full" onClick={props.onClose}>
              {t('back_button')}
            </SecondaryButton>
          </div>

          <div className="flex-1 min-w-[150px]">
            <PrimaryButton className="w-full" onClick={handleCheckStatus}>
              {t('check_status_button')}
            </PrimaryButton>
          </div>
        </Flex.Wrapper>
      )}
    </BaseModal>
  );
};

export default CompanyVerificationRequiredModal;
